import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthProvider';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import RequireAuth from './Components/RequireAuth';
import PersistLogin from './Components/PersistLogin';
import NiceSuccess from './Components/NiceSuccess';
import LayOut from './Components/Layout';
import Unauthorized from './Components/Unauthorized';
import AdminPage from './Components/AdminPage';
const root = ReactDOM.createRoot(document.getElementById('root'));
const ROLES = {

  'Admin': 5150
}

root.render(
  <BrowserRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>

);

/* 
<BrowserRouter>
    <AuthProvider>
      <Routes>
        <Route path="/" element={<LayOut />} >
          <Route path="/" element={<App />} />
          <Route path="success" element={<NiceSuccess />} />
          <Route path="unauthorized" element={<Unauthorized />} />
          <Route element={<PersistLogin />}>
            <Route element={<RequireAuth allowedRoles={[ROLES.Admin]} />}>
              <Route path="/admin" element={<AdminPage />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </AuthProvider>
  </BrowserRouter>
*/
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
